import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the office clicks Send Feedback in the Account menu.
 * Event: dental_portal:account:send_feedback_clicked
 *
 * This is the trigger for the Platform Feedback survey — PostHog watches for
 * the event and renders the popover, so the menu item fires it instead of
 * navigating anywhere.
 */
export function fireAccountSendFeedbackClicked(): void {
  PosthogService.getInstance().track('dental_portal:account:send_feedback_clicked');
}
